import {
  SchoolOfficerRoleEnum,
  SchoolOfficerStatusEnum,
  UserCategoryEnum,
} from "@/shared/ModelEnums";

import PaymentSourceModel from "./PaymentSourceModel";
import { UserViewModel } from "./UserModel";

export default class SchoolOfficerViewModel extends UserViewModel {
  schoolOfficerId?: number;

  position: string;

  schoolReference: string = "";
  schoolOfficerRoleCd: SchoolOfficerRoleEnum = SchoolOfficerRoleEnum.SOR_P; //Principal.
  schoolOfficerDeclarationCd: string = "";
  schoolName: string = "";
  comments: string = "";
  schoolOfficerStatusCd: SchoolOfficerStatusEnum =
    SchoolOfficerStatusEnum.SOS_I;
  paymentSource?: PaymentSourceModel;

  defaultPaymentSource?: PaymentSourceModel;

  constructor() {
    super();

    this.userCategoryCd = UserCategoryEnum.UC_S; // School Officer
    this.userStatusCd = "US_A";
    this.position = "";
    this.schoolOfficerDeclarationCd = "SOD_P"; //Pending.
  }
}
